module.exports = "/_next/static/images/Trim-a72dbad15f11f2d8c3ebe8225fa7212b.gif";